import script from "./SogCheckBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./SogCheckBox.vue?vue&type=script&setup=true&lang=ts"

import "./SogCheckBox.vue?vue&type=style&index=0&id=00bc6c8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00bc6c8a"]])

export default __exports__